import { Controller } from "@hotwired/stimulus"

const SIDEBAR_STATE_KEY = "tdverifier.admin.sidebar.open"

// 管理画面サイドバーの開閉を制御するコントローラ
export default class extends Controller {
  static targets = ["panel", "toggle", "backdrop", "iconOpen", "iconClose", "content"]

  connect() {
    const persistedState = this.readPersistedState()

    if (persistedState === true) {
      this.open({ quiet: true, skipStore: true })
    } else if (persistedState === false) {
      this.close({ quiet: true, skipStore: true })
    } else if (this.isMobile()) {
      this.close({ quiet: true, skipStore: true })
    } else {
      this.open({ quiet: true, skipStore: true })
    }
  }

  toggle(event) {
    event?.preventDefault()
    this.isOpen() ? this.close() : this.open()
  }

  open(options = {}) {
    this.panelTarget.classList.add("translate-x-0")
    this.panelTarget.classList.remove("-translate-x-full")
    this.syncBackdrop()
    this.updateToggleState(true)
    this.updateContentSpacing(true)
    if (!options.skipStore) {
      this.persistState(true)
    }
    if (!options.quiet) {
      this.focusFirstLink()
    }
  }

  close(options = {}) {
    this.panelTarget.classList.add("-translate-x-full")
    this.panelTarget.classList.remove("translate-x-0")
    this.syncBackdrop()
    this.updateToggleState(false)
    this.updateContentSpacing(false)
    if (!options.skipStore) {
      this.persistState(false)
    }
    if (!options.quiet) {
      this.returnFocusToToggle()
    }
  }

  closeOnEscape(event) {
    if (event.key === "Escape" && this.isOpen()) {
      this.close()
    }
  }

  isOpen() {
    return this.panelTarget.classList.contains("translate-x-0")
  }

  syncBackdrop() {
    const shouldShowBackdrop = this.isOpen() && this.isMobile()

    this.backdropTargets.forEach((backdrop) => {
      backdrop.classList.toggle("hidden", !shouldShowBackdrop)
    })
  }

  updateToggleState(expanded) {
    this.toggleTargets.forEach((button) => {
      button.setAttribute("aria-expanded", expanded)
    })

    this.iconOpenTargets.forEach((icon) => {
      icon.classList.toggle("hidden", expanded)
    })

    this.iconCloseTargets.forEach((icon) => {
      icon.classList.toggle("hidden", !expanded)
    })
  }

  focusFirstLink() {
    if (!this.isMobile()) return

    const firstLink = this.panelTarget.querySelector("a")
    firstLink?.focus()
  }

  returnFocusToToggle() {
    const [firstToggle] = this.toggleTargets
    firstToggle?.focus()
  }

  updateContentSpacing(expanded) {
    this.contentTargets.forEach((content) => {
      content.classList.toggle("md:ml-64", expanded)
      content.classList.toggle("md:ml-0", !expanded)
    })
  }

  isMobile() {
    return window.matchMedia("(max-width: 1023px)").matches
  }

  persistState(open) {
    try {
      window.localStorage.setItem(SIDEBAR_STATE_KEY, JSON.stringify(open))
    } catch (error) {
      console.warn("Failed to persist sidebar state", error)
    }
  }

  readPersistedState() {
    try {
      const value = window.localStorage.getItem(SIDEBAR_STATE_KEY)

      if (value === null) return null

      return JSON.parse(value)
    } catch (error) {
      console.warn("Failed to read sidebar state", error)
      return null
    }
  }
}
